import { render, staticRenderFns } from "./StringFormatter.WordCount.vue?vue&type=template&id=0475ba05&scoped=true"
import script from "./StringFormatter.WordCount.vue?vue&type=script&lang=js"
export * from "./StringFormatter.WordCount.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.WordCount.vue?vue&type=style&index=0&id=0475ba05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475ba05",
  null
  
)

export default component.exports